import $ from 'jquery';
import routeLocale from '../../common/routeLocale';
import { getTranslatedMessages } from '../../translates';

function toggleStateCity(content, show) {
    var selectCountry = content.find('select[name="country_id"]');
    var stateParent = content.find('select[name="state_id"]').parent();
    var cityParent = content.find('select[name="city_id"]').parent();

    const inputState = content.find('input[name="state"]');
    const inputCity = content.find('input[name="city"]');

    stateParent.toggleClass('hidden', !show);
    cityParent.toggleClass('hidden', !show);

    stateParent.attr('hidden', !show);
    cityParent.attr('hidden', !show);

    //State/City input
    inputState.parent().addClass('hidden');
    inputCity.parent().addClass('hidden');
    if (inputState.length > 0 && selectCountry.val()) {
        if (show) {
            inputState.parent().addClass('hidden');
            inputCity.parent().addClass('hidden');
        } else {
            inputState.parent().removeClass('hidden');
            inputCity.parent().removeClass('hidden');
        }
    }
}

export function setupSelectCountryStateCity(container, withDealer = false, hideStateCityWhenNotBrazil = false,) {
    const selectCountry = container.find('select[name="country_id"]');
    const selectState = container.find('select[name="state_id"]');
    const selectCity = container.find('select[name="city_id"]');
    const locationFillDiv = container.find('.location-fill');

    setupPhoneMask(container);

    selectCountry.on('change', function () {
        var v = $(this).val();

        selectState.empty();
        selectCity.empty();

        container.find('input[name="phone"]').val('');

        if (!v) {
            toggleStateCity(container, false);
            return;
        }

        // 1 = Brasil, 73 = Russia
        var allowedValues = ['1', '73'];

        if (hideStateCityWhenNotBrazil && !allowedValues.includes(v)) {
            selectState.parent().addClass('hidden');
            selectCity.parent().addClass('hidden');
            selectState.val('');
            selectCity.val('');
            locationFillDiv.removeClass('col-span-4').addClass('col-span-8').removeClass('sm:hidden');
            return;
        }

        if (allowedValues.includes(v)) {
            locationFillDiv.removeClass('col-span-8').addClass('col-span-4');
        } else {
            locationFillDiv.removeClass('col-span-4').addClass('col-span-8');
        }

        $.get(routeLocale('/api/contato/estados/' + v + '/' + withDealer)).then(function (rs) {
            selectState.append(new Option(getTranslatedMessages().select_state, ''));
            selectCity.append(new Option(getTranslatedMessages().select_city, ''));
            $.each(rs, function (index, item) {
                selectState.append(new Option(index, item));
            });

            toggleStateCity(container, rs.length != 0);

            selectCity.parent().addClass('hidden');
        });
    });

    selectState.on('change', function () {
        var v = $(this).val();
        selectCity.empty();

        if (!v) {
            return;
        }

        locationFillDiv.addClass('sm:hidden');

        $.get(routeLocale('/api/contato/cidades/' + v + '/' + withDealer)).then(function (rs) {
            selectCity.append(new Option(getTranslatedMessages().select_city, ''));
            $.each(rs, function (index, item) {
                selectCity.append(new Option(index, item));
            });

            if (rs.length == 0) {
                selectCity.parent().addClass('hidden');
            } else {
                selectCity.parent().removeClass('hidden');
            }
        });
    });

    selectCountry.trigger('change');
}

export function setupSelectStateCity(container) {
    const selectCountry = container.find('select[name="country_id"]');
    const selectState = container.find('select[name="state_id"]');
    const selectCity = container.find('select[name="city_id"]');
    const locationFillDiv = container.find('.location-fill');

    selectState.empty();
    selectCity.empty();

    var v = selectCountry.val();
    if (!v) {
        toggleStateCity(container, false);
        return;
    }

    $.get(routeLocale('/api/contato/estados/' + v)).then(function (rs) {
        selectState.append(new Option(getTranslatedMessages().select_state, ''));
        selectCity.append(new Option(getTranslatedMessages().select_city, ''));
        $.each(rs, function (index, item) {
            selectState.append(new Option(index, item));
        });

        toggleStateCity(container, rs.length != 0);
    });

    selectState.on('change', function () {
        var v = $(this).val();
        selectCity.empty();

        if (!v) {
            return;
        }

        locationFillDiv.addClass('sm:hidden');

        $.get(routeLocale('/api/contato/cidades/' + v)).then(function (rs) {
            selectCity.append(new Option(getTranslatedMessages().select_city, ''));
            $.each(rs, function (index, item) {
                selectCity.append(new Option(index, item));
            });
        });
    });
}

function setupPhoneMask(container) {
    $(container.find('input[name="phone"]')).on('input', function () {
        let countryId = container.find('select[name="country_id"]').val();

        if (countryId == '1') {
            var value = $(this).val().replace(/\D/g, '');
            if (value.length > 11) {
                value = value.slice(0, 11);
            }

            var formattedValue =
                value.length == 10
                    ? value.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2')
                    : value.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');

            $(this).val(formattedValue);
        } else {
            $(this).val($(this).val().replace(/\D/g, '').slice(0, 13));
        }
    });
}